import LinksSection, { LinksSectionProps } from './LinksSection';

export default LinksSection;
export type { LinksSectionProps };
